<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">变更时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          @on-change="searchParams.date = $event"
        >
        </DatePicker>
      </div>

      <div class="input-item">
        <span class="label">名称</span>
        <Input v-model="searchParams.fieldName" placeholder="请输入" clearable />
      </div>

      <div class="input-item">
        <span class="label">变更人</span>
        <Select v-model="searchParams.updateId" :transfer="true" clearable filterable>
          <Option :value="item.createBy" v-for="(item, index) in changedByList" :key="index">{{ item.name }}</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="search()">搜索</Button>
      </div>
    </div>

    <div class="table-box template-table">
      <loading :isShow="tableLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="beforeChange">
          <div class="change" v-if="row.oldValue">
            <span
              v-if="
                row.field == 'payment' ||
                row.field == 'payType' ||
                row.field == 'includingDeath' ||
                row.field == 'doubleRecordStatus' ||
                row.field == 'status' || 
                row.field == 'sellType' ||
                row.field == 'sellResource' ||
                row.field == 'isSelfHold' ||
                row.field == 'isMutualHold' ||
                row.field == 'hasSocialInsurance' ||
                row.field == 'sex' ||
                row.field == 'familyRelationShip' ||
                row.field == 'holderIdType' ||
                row.field == 'idType' ||
                row.field == 'holderSex' ||
                row.field == 'guaranteeType' ||
                row.field == 'beneficiaryType' ||
                row.field == 'customerNoticeList'
              "
              >{{ row.oldStatusName }}</span
            >
            <span v-else>
              <span v-if="row.eyeShow1">{{ row.oldValueMd }}</span>
              <span v-else>{{ row.oldValue }}</span>
            </span>
            <div
              class="change-eye"
              v-if="
                row.field == 'idNo' ||
                row.field == 'holderIdNo' ||
                row.field == 'holderMobile' ||
                row.field == 'holderEmail' ||
                row.field == 'mobile' ||
                row.field == 'email' ||
                row.field == 'cardNo' ||
                row.field == 'holderAddress' 

              "
            >
              <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 1, 'oldValueMd', 'eyeShow1')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 1, 'oldValueMd', 'eyeShow1')"></i>
            </div>
          </div>
          <div v-else-if="row.field == 'insuranceInfoList' || row.field == 'insuranceContractList' || row.field == 'otherInfoList' || row.field == 'rights'">
            <span v-if="row.oldValue">{{ row.oldValue }}</span>
            <span v-else>-</span>
          </div>
          <div v-else>-</div>
        </template>

        <template slot-scope="{ row }" slot="afterChange">
          <div class="change" v-if="row.newValue">
            <span
              v-if="
                row.field == 'payment' ||
                row.field == 'payType' ||
                row.field == 'includingDeath' ||
                row.field == 'doubleRecordStatus' ||
                row.field == 'status' || 
                row.field == 'sellType' ||
                row.field == 'sellResource' ||
                row.field == 'isSelfHold' ||
                row.field == 'beneficiaryType' ||
                row.field == 'isMutualHold' ||
                row.field == 'hasSocialInsurance' ||
                row.field == 'sex' ||
                row.field == 'familyRelationShip' ||
                row.field == 'holderIdType' ||
                row.field == 'idType' ||
                row.field == 'holderSex' ||
                row.field == 'guaranteeType' ||
                row.field == 'customerNoticeList'
              "
              >{{ row.newStatusName }}</span
            >
            <span v-else>
              <span v-if="row.eyeShow2">{{ row.newValueMd }}</span>
              <span v-else>{{ row.newValue }}</span>
            </span>
            <div
              class="change-eye"
              v-if="
                row.field == 'idNo' ||
                row.field == 'holderIdNo' ||
                row.field == 'holderMobile' ||
                row.field == 'holderEmail' ||
                row.field == 'mobile' ||
                row.field == 'email' ||
                row.field == 'cardNo'||
                row.field == 'holderAddress' 
              "
            >
              <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow2" @click="openEye(row, 2, 'newValueMd', 'eyeShow2')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 2, 'newValueMd', 'eyeShow2')"></i>
            </div>
          </div>
          <div v-else-if="row.field == 'insuranceInfoList' || row.field == 'insuranceContractList' || row.field == 'otherInfoList' || row.field == 'rights'">
            <span v-if="row.newValue">{{ row.newValue }}</span>
            <span v-else>-</span>
          </div>
          <div v-else>-</div>
        </template>
      </Table>
      <no-data v-else style="margin-top: 10px"></no-data>
    </div>

    <div class="pageBox">
      <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" />
    </div>
  </div>
</template>

<script>
import filters from '@/api/filter';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  name: 'info',
  props: ['policyNo'],
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 60
        },
        {
          title: '名称',
          key: 'fieldName',
          align: 'center',
          minWidth: 150,
          ellipsis: true,
          tooltip: true
        },
        {
          title: '变更前',
          align: 'center',
          minWidth: 240,
          slot: 'beforeChange', 
        },
        {
          title: '变更后',
          align: 'center',
          minWidth: 240,
          slot: 'afterChange'
        },
        {
          title: '变更人',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            const result = params.row.operator;
            return <span>{result ? result : '-'}</span>;
          }
        },
        {
          title: '变更时间',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            const result = params.row.createTime;
            return <span>{filters.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
          }
        }
      ],
      tableData: [],
      changedByList: [],
      total: 0,
      searchParams: {
        pageNo: 1,
        pageSize: 10,
        type: '1'
      },
      // 交费单位
      paymentType: {
        1: '年',
        2: '月',
        3: '岁',
        4: '年'
      },
      // 交费方式
      payTypeType: {
        1: '年交',
        2: '月交',
        3: '季交',
        4: '半年交',
        7: '趸交'
      },
      // 是否含身故
      includingDeathType: {
        0: '不含身故',
        1: '含身故'
      },
      // 业务类型
      sellType: {
        1: '网销',
        2: '电销',
        3: '经代'
      },
      // 业务来源
      sellResourceType: {
        1: '分销',
        2: '直营'
      },
      // 是否自保件
      isSelfHoldType: {
        0: '否',
        1: '是'
      },
      // 是否互保件
      isMutualHoldType: {
        0: '否',
        1: '是'
      },
      // 有无社保
      hasSocialInsuranceType: {
        0: '无',
        1: '有'
      },
      // 性别
      sexType: {
        1: '男',
        2: '女'
      },
      MARITAL_STATUS: JSON.parse(localStorage.getItem('dic')).MARITAL_STATUS, //婚姻状况
      // 投保人证件类型
      holderIdType: {
        1: '身份证',
        2: '护照',
        3: '军人证',
        5: '户口本',
        6: '出生证',
        4: '其他'
      },
      // 被保人证件类型
      idType: {
        1: '身份证',
        2: '护照',
        4: '其他',
        3: '军人证',
        5: '户口本',
        6: '出生证'
      },
      // 投保人性别
      holderSexType: {
        1: '男',
        2: '女'
      },
      // 保障类型
      guaranteeType: {
        1: '终身',
        2: '周岁',
        3: '年',
        5: '天'
      },
      POLICY_STATUS: JSON.parse(localStorage.getItem('dic')).POLICY_STATUS //保单状态
    };
  },

  created() {
    this.getInitList();
  },
  mounted() {
    this.getChangedBy();
  },
  methods: {
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchParams));
      if (obj.date && obj.date[0]) {
        obj.beginUpdateTime = filters.filterTime(obj.date[0], 'YYYY-MM-DD');
        obj.endUpdateTime = filters.filterTime(obj.date[1], 'YYYY-MM-DD');
      }
      delete obj.date;
      let { ...params } = obj;
      return params;
    },

    getInitList() {
      this.tableLoading = true;
      this.$http({
        url: `/buz/policyChangeRecord/read/list`,
        type: 'POST',
        data: this.setRequestParam()
      })
        .then(res => {
          const dic = JSON.parse(localStorage.dic);
          res.data.forEach(item => {
            if (item.field == 'payment') {
              item.oldStatusName = this.paymentType[item.oldValue];
              item.newStatusName = this.paymentType[item.newValue];
            } else if (item.field == 'payType') {
              item.oldStatusName = this.payTypeType[item.oldValue];
              item.newStatusName = this.payTypeType[item.newValue];
            } else if (item.field == 'rights') {
              item.newValue = item.newValue ? JSON.parse(item.newValue)[0].content : '-';
              item.oldValue = item.oldValue ? JSON.parse(item.oldValue)[0].content : '-';
            } else if (item.field == 'includingDeath') {
              item.oldStatusName = this.includingDeathType[item.oldValue];
              item.newStatusName = this.includingDeathType[item.newValue];
            } else if (item.field == 'doubleRecordStatus') {
              // 双录状态
              item.oldStatusName = dic.DOUBLE_STATUS[item.oldValue];
              item.newStatusName = dic.DOUBLE_STATUS[item.newValue];
            } else if (item.field == 'sellType') {
              item.oldStatusName = this.sellType[item.oldValue];
              item.newStatusName = this.sellType[item.newValue];
            } else if (item.field == 'sellResource') {
              item.oldStatusName = this.sellResourceType[item.oldValue];
              item.newStatusName = this.sellResourceType[item.newValue];
            } else if (item.field == 'isSelfHold') {
              item.oldStatusName = this.isSelfHoldType[item.oldValue];
              item.newStatusName = this.isSelfHoldType[item.newValue];
            } else if (item.field == 'isMutualHold') {
              item.oldStatusName = this.isMutualHoldType[item.oldValue];
              item.newStatusName = this.isMutualHoldType[item.newValue];
            } else if (item.field == 'hasSocialInsurance') {
              item.oldStatusName = this.hasSocialInsuranceType[item.oldValue];
              item.newStatusName = this.hasSocialInsuranceType[item.newValue];
            } else if (item.field == 'beneficiaryType') {
              item.oldStatusName = item.oldValue == '1'?'法定受益人':'指定受益人';
              item.newStatusName = item.newValue == '1'?'法定受益人':'指定受益人';
            }  else if (item.field == 'sex') {
              item.oldStatusName = this.sexType[item.oldValue];
              item.newStatusName = this.sexType[item.newValue];
            } else if (item.field == 'familyRelationShip') {
              item.oldStatusName = this.MARITAL_STATUS[item.oldValue]; 
              item.newStatusName = this.MARITAL_STATUS[item.newValue]; 
            } else if (item.field == 'holderIdType') {
              item.oldStatusName = this.holderIdType[item.oldValue];
              item.newStatusName = this.holderIdType[item.newValue];
            } else if (item.field == 'idType') {
              item.oldStatusName = this.idType[item.oldValue];
              item.newStatusName = this.idType[item.newValue];
            } else if (item.field == 'holderSex') {
              item.oldStatusName = this.holderSexType[item.oldValue];
              item.newStatusName = this.holderSexType[item.newValue];
            } else if (item.field == 'guaranteeType') {
              item.oldStatusName = this.guaranteeType[item.oldValue];
              item.newStatusName = this.guaranteeType[item.newValue];
            } else if (item.field == 'customerNoticeList') {
              item.oldStatusName = item.oldValue;
              item.newStatusName = item.newValue;
            } else if (item.field == 'status') { 
              //保单状态
              item.oldStatusName = this.POLICY_STATUS[item.oldValue];
              item.newStatusName = this.POLICY_STATUS[item.newValue];
            }
          });
          this.tableData = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    // 获取变更人
    getChangedBy(policyNo) {
      this.$http({
        url: `/buz/policyChangeRecord/selectUserInfo`,
        type: 'GET',
        data: {
          policyNo: policyNo || this.policyNo
        }
      }).then(res => {
        this.changedByList = res.data;
      });
    },

    // 搜索
    search() {
      this.searchParams.pageNo = 1;
      this.getInitList();
    },

    // 分页
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getInitList();
    },

    // 解密
    /*
            type: 变更前：1、变更后：2
            key: 变更前：oldValueMd、变更后：newValueMd
        */
    openEye(row, type, key, eyeShow) {
      if (!row[eyeShow]) {
        this.descrypt(
          {
            query: row.id,
            operationFunction: 10,
            operationType: type
          },
          row,
          key
        ).then(() => {
          this.$set(row, eyeShow, true);
        });
      } else {
        this.$set(row, eyeShow, false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  .input-item {
    width: 300px !important;
  }
}
.table-box {
  .change {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .change-eye {
      margin-left: 5px;
    }
  }
}
</style>
